/// <reference types="@angular/localize" />

import * as $ from 'jquery';
(window as any)['jQuery'] = $;
(window as any)['$'] = $;

// Bootstrap 5 dropped jQuery plugins — register Tooltip and Popover as jQuery
// plugins so Summernote BS5 can call $(el).tooltip() / $(el).popover()
($ as any).fn.tooltip = function (this: any, options: any) {
  return this.each(function (this: any) {
    const bs = (window as any).bootstrap;
    if (!bs?.Tooltip) return;
    if (typeof options === 'string') {
      const instance = bs.Tooltip.getInstance(this);
      if (instance) instance[options]();
    } else {
      new bs.Tooltip(this, Object.assign({ trigger: 'hover' }, options || {}));
    }
  });
};

($ as any).fn.popover = function (this: any, options: any) {
  return this.each(function (this: any) {
    const bs = (window as any).bootstrap;
    if (!bs?.Popover) return;
    if (typeof options === 'string') {
      const instance = bs.Popover.getInstance(this);
      if (instance) instance[options]();
    } else {
      new bs.Popover(this, options || {});
    }
  });
};

import 'summernote/dist/summernote-bs5.min.js';

import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { defineCustomElements } from '@truckit/shared-ui/loader';
import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

// Load the Google Maps JS API using the environment-specific key so local
// dev can use its own key while other builds keep the shared one.
const mapsScript = document.createElement('script');
mapsScript.src = `//maps.google.com/maps/api/js?key=${environment.googleMapAPIKey}&libraries=geometry,places&region=AU`;
mapsScript.async = true;
mapsScript.defer = true;
document.body.appendChild(mapsScript);

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .catch((err) => console.error(err));

defineCustomElements(window);
